import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { MessageModal } from '@/components/message-modal'
import { useConfirmUser } from '@/hooks/queries/use-confirm-user'
import { useAuth } from '@/hooks/use-auth'
import { useTimeLeft } from '@/hooks/use-time-left'
import { routes } from '@/routes/config'

interface AccountProps {
  token: string
}

export function Account({ token }: AccountProps) {
  const navigate = useNavigate()
  const { isAuthenticated, signOut } = useAuth()

  const { timeLeft, setTimeLeft } = useTimeLeft(() => navigate(routes.Login()))

  const { isFetching, isError, isSuccess } = useConfirmUser(
    token,
    'confirmAccount',
  )

  useEffect(() => {
    if (isSuccess) {
      if (isAuthenticated) signOut()

      setTimeLeft(5)
    }
  }, [isSuccess])

  if (isFetching)
    return (
      <MessageModal
        title='Confirmação de e-mail'
        message='Confirmando e-mail...'
      />
    )

  if (isError)
    return (
      <MessageModal
        title='Não foi possível confirmar o e-mail'
        message='Tente novamente mais tarde.'
        type='error'
      />
    )

  return (
    <MessageModal
      title='E-mail confirmado'
      message={`Você será redirecionado para a página de login em ${timeLeft} segundos.`}
    />
  )
}
